import { render, staticRenderFns } from "./cooprationRule.vue?vue&type=template&id=a6b0a4c2&scoped=true"
import script from "./cooprationRule.vue?vue&type=script&lang=js"
export * from "./cooprationRule.vue?vue&type=script&lang=js"
import style0 from "./cooprationRule.vue?vue&type=style&index=0&id=a6b0a4c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b0a4c2",
  null
  
)

export default component.exports